import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class AccountFeatures extends Component {
  static propTypes = {
    allFeatures: PropTypes.instanceOf(Array),
    activeFeatures: PropTypes.instanceOf(Array),
    roleName: PropTypes.string,
    handlePermissionChange: PropTypes.func,
  };

  static defaultProps = {
    allFeatures: [],
    activeFeatures: [],
  };

  state = {
    allFeatures: [],
    activeFeatures: [],
  };

  UNSAFE_componentWillMount() {
    const { allFeatures, activeFeatures } = this.props;
    this.updateInitialState(allFeatures, activeFeatures);
  }

  UNSAFE_componentWillReceiveProps({ allFeatures, activeFeatures }) {
    if (!_.isEqual(activeFeatures, this.state.activeFeatures)) {
      this.updateInitialState(allFeatures, activeFeatures);
    }
  }

  updateInitialState = (allFeatures, activeFeatures) => {
    const features = [];
    if (!_.isEmpty(allFeatures)) {
      _.map(allFeatures, feature => {
        const permissions = [];
        const activeFeature = _.filter(
          activeFeatures,
          j => j.moduleId === feature.moduleId
        );
        _.map(feature.permissions, item => {
          const isActive =
            activeFeature[0] &&
            _.filter(activeFeature[0].permissions, k => k.id === item.id);
          const isChecked = !_.isEmpty(isActive);
          const obj = {
            ...item,
            isChecked,
          };
          permissions.push(obj);
        });
        const featureObj = {
          ...feature,
          permissions,
        };
        features.push(featureObj);
      });
    }
    this.setState({ allFeatures: features, activeFeatures });
  };

  handlePermission = (isChecked, moduleId, id) => {
    const { allFeatures } = this.state;
    const features = [];
    _.map(allFeatures, feature => {
      let permissions = feature.permissions;
      if (feature.moduleId === moduleId) {
        permissions = _.map(feature.permissions, item => {
          let obj = item;
          if (item.id === id) {
            obj = {
              ...item,
              isChecked: !isChecked,
            };
          }
          return obj;
        });
      }
      const featureObj = {
        ...feature,
        permissions,
      };
      features.push(featureObj);
    });
    this.setState({ allFeatures: features }, () => {
      this.props.handlePermissionChange(this.state.allFeatures);
    });
  };

  handleAllPermissions = (isChecked, moduleId) => {
    const { allFeatures } = this.state;
    const features = [];
    _.map(allFeatures, feature => {
      let permissions = feature.permissions;
      if (feature.moduleId === moduleId) {
        permissions = _.map(feature.permissions, item => {
          const obj = {
            ...item,
            isChecked: !isChecked,
          };
          return obj;
        });
      }
      const featureObj = {
        ...feature,
        permissions,
      };
      features.push(featureObj);
    });
    this.setState({ allFeatures: features }, () => {
      this.props.handlePermissionChange(this.state.allFeatures);
    });
  };

  renderPermissions = (moduleId, permissions) => {
    const domElem = _.map(permissions, permission => {
      const { id, name, isChecked } = permission;
      const roles = this.props.roleName.split('_');
      const isRldRole = roles.includes('RLD'); // only specific RLD role can have the RLD permission
      const isAccRole = roles.includes('ACC'); // only specific ACC role can have the ACC permission
      const isRld = (!isRldRole && id === 14) || (isRldRole && id !== 14);
      const isAcc = (!isAccRole && id === 17) || (isAccRole && id !== 17);
      return (
        <div
          key={`${moduleId}_${name}_${id}`}
          className="accounts-role-feature--checkbox"
        >
          <input
            type="checkbox"
            id={`${moduleId}_${name}_${id}`}
            name={`${moduleId}_${name}_${id}`}
            checked={isChecked && !(isRld || isAcc)}
            onChange={() => this.handlePermission(isChecked, moduleId, id)}
            disabled={isRld || isAcc} // disable checkbox for RLD or ACC roles
          />
          <label htmlFor={`${moduleId}_${name}_${id}`}>
            <span className="accounts-role-feature--name crosstab-icon">
              {name}
            </span>
          </label>
        </div>
      );
    });
    return domElem;
  };

  renderFeatures = () => {
    const { allFeatures } = this.state;
    const domElem = _.map(allFeatures, feature => {
      const { moduleName, moduleId, permissions } = feature;
      const roles = this.props.roleName.split('_');
      const isRldRole = roles.includes('RLD'); // only specific RLD role can have the RLD permission
      const isAccRole = roles.includes('ACC'); // only specific ACC role can have the ACC permission
      const isRld = (!isRldRole && moduleId === 5) || (isRldRole && moduleId !== 5);
      const isAcc = (!isAccRole && moduleId === 6) || (isAccRole && moduleId !== 6);
      const activePremission = _.map(permissions, item => item.isChecked);
      const isChecked = !_.includes(activePremission, false) && !(isRld || isAcc);
      const moduleIconClass = `${moduleName.replaceAll(' ', '').toLowerCase()}_icon`;
      return (
        <div
          key={`${moduleName}_${moduleId}`}
          className="accounts-role-feature"
        >
          <div className="accounts-role-feature--header">
            <div className="accounts-role-feature--checkbox">
              <input
                type="checkbox"
                id={`roleFeature${moduleName}`}
                name={`roleFeature${moduleName}`}
                checked={isChecked}
                onChange={() => this.handleAllPermissions(isChecked, moduleId)}
                disabled={isRld || isAcc} // disabled checkbox for RLD or ACC roles
              />
              <label htmlFor={`roleFeature${moduleName}`}>
                <span
                  className={`accounts-role-feature--name ${moduleIconClass}`}
                >
                  {moduleName}
                </span>
              </label>
            </div>
          </div>
          <div className="accounts-role-feature--list">
            {this.renderPermissions(moduleId, permissions)}
          </div>
        </div>
      );
    });
    return domElem;
  };

  render() {
    if (_.isEmpty(this.state.allFeatures)) {
      return (
        <div className="accounts-role-features">
          <div className="no-result-message">
            There are no modules currently assigned to this account.
            &nbsp;Please contact your MRI-Simmons account team for assistance.
          </div>
        </div>
      );
    }
    return (
      <div className="accounts-role-features-box">
        <div className="accounts-role-features--header">
          <h4>Select Module(s)</h4>
        </div>
        <div className="accounts-role-features">{this.renderFeatures()}</div>
      </div>
    );
  }
}

export default AccountFeatures;
